import React from 'react';
import './Features.css';
import useInView from '../hooks/useInView';

const Features = () => {
  const { elementRef: componentsRef, hasBeenInView: componentsInView } = useInView();
  const { elementRef: whyChooseRef, hasBeenInView: whyChooseInView } = useInView();
  const { elementRef: howItWorksRef, hasBeenInView: howItWorksInView } = useInView();

  return (
    <section className="features" id="caratteristiche">
      <div className="container">
        {/* Due Componenti Section */}
        <div 
          className={`components-section ${componentsInView ? 'animate-fade-in-up' : ''}`}
          ref={componentsRef}
        >
          <h2 className="section-title">
            DUE COMPONENTI, UNA PROTEZIONE TOTALE
          </h2>
          
          <div className="components-grid">
            <div className="component-card">
              <div className="component-icon">
                <div className="icon-wrapper">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z" fill="currentColor"/>
                    <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div className="icon-pulse"></div>
                </div>
              </div>
              <h3 className="component-title">APPLICAZIONE PRINCIPALE</h3>
              <p className="component-description">
                <span className="highlight-blue">Monitoraggio continuo del sistema</span> in tempo reale. Rileva e neutralizza 
                virus, malware e <span className="highlight-yellow">minacce avanzate</span> con tecnologia italiana all'avanguardia.
              </p>
              <div className="component-features">
                <span className="feature-tag">Real-time</span>
                <span className="feature-tag">AI-Powered</span>
                <span className="feature-tag">Zero Impact</span>
              </div>
            </div>
            
            <div className="component-card">
              <div className="component-icon">
                <div className="icon-wrapper">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" fill="currentColor"/>
                    <path d="M8 12H16M12 8V16" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="3 3"/>
                  </svg>
                  <div className="icon-pulse"></div>
                </div>
              </div>
              <h3 className="component-title">ESTENSIONE BROWSER</h3>
              <p className="component-description">
                <span className="highlight-yellow">Protezione intelligente</span> contro phishing e social engineering. 
                Analizza email e siti web per bloccare <span className="highlight-blue">truffe e tentativi di frode</span> in tempo reale.
              </p>
              <div className="component-features">
                <span className="feature-tag">Anti-Phishing</span>
                <span className="feature-tag">Web Protection</span>
                <span className="feature-tag">Smart Filter</span>
              </div>
            </div>
          </div>
        </div>

        {/* Perché Scegliere Noi Section */}
        <div 
          className={`why-choose-section ${whyChooseInView ? 'animate-fade-in-up' : ''}`}
          ref={whyChooseRef}
        >
          <h2 className="section-title">PERCHÉ SCEGLIERE NOI</h2>
          
          <div className="features-grid">
            <div className="feature-item">
              <div className="feature-check">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                Sviluppato in Italia con <span className="feature-highlight">tecnologie Europee</span>.
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-check">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                <span className="feature-highlight">Sicurezza avanzata</span> contro minacce moderne.
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-check">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                Protezione <span className="feature-highlight">email e web</span> integrata.
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-check">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                Protezione veloce <span className="feature-highlight">senza rallentare il PC</span>.
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-check">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                Facile da usare <span className="feature-highlight">per tutti</span> i livelli di esperienza.
              </div>
            </div>
            
            <div className="feature-item">
              <div className="feature-check">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="feature-content">
                Difesa completa <span className="feature-highlight">24/7 automatica</span>.
              </div>
            </div>
          </div>
        </div>

        {/* Come Funziona Section */}
        <div 
          className={`how-it-works-section ${howItWorksInView ? 'animate-fade-in-up' : ''}`}
          ref={howItWorksRef}
        >
          <h2 className="section-title">COME FUNZIONA?</h2>
          
          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">
                <span>1</span>
                <div className="step-progress"></div>
              </div>
              <h3 className="step-title">INSTALLAZIONE SEMPLICE</h3>
              <p className="step-description">
                <span className="highlight-blue">Scarica e installa</span> l'antivirus in pochi minuti. 
                L'installazione è <span className="highlight-yellow">guidata e automatica</span>.
              </p>
              <div className="step-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            
            <div className="step-card">
              <div className="step-number">
                <span>2</span>
                <div className="step-progress"></div>
              </div>
              <h3 className="step-title">PROTEZIONE IMMEDIATA</h3>
              <p className="step-description">
                Il sistema inizia subito a <span className="highlight-yellow">monitorare il tuo PC</span> e a proteggere 
                la tua <span className="highlight-blue">navigazione web</span>.
              </p>
              <div className="step-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            
            <div className="step-card">
              <div className="step-number">
                <span>3</span>
                <div className="step-progress"></div>
              </div>
              <h3 className="step-title">SICUREZZA CONTINUA</h3>
              <p className="step-description">
                Lavora <span className="highlight-blue">silenziosamente in background</span>, aggiornandosi 
                automaticamente contro <span className="highlight-yellow">nuove minacce</span>.
              </p>
              <div className="step-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23 4V10H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20.49 15C19.9828 16.8393 18.9228 18.4804 17.4612 19.7006C15.9996 20.9207 14.205 21.6584 12.2968 21.8329C10.3886 22.0073 8.46813 21.6109 6.7831 20.6929C5.09807 19.7748 3.71069 18.3788 2.7925 16.6938C1.87431 15.0087 1.47787 13.1083 1.65231 11.2001C1.82676 9.29192 2.56447 7.49734 3.78462 6.03571C5.00478 4.57408 6.64584 3.51405 8.48517 3.00693C10.3245 2.49981 12.2844 2.56284 14.09 3.19L20 9.09" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features; 